import { render, staticRenderFns } from "./cgv.vue?vue&type=template&id=5afff0a9&"
import script from "./cgv.vue?vue&type=script&lang=js&"
export * from "./cgv.vue?vue&type=script&lang=js&"
import style0 from "./cgv.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports